let mapDot = {
	//省份 河北
		石家庄: [114.48, 38.03],
		唐山: [118.02, 39.63],
		秦皇岛: [119.57, 39.95],
		邯郸: [114.47, 36.6],
		邢台: [114.48, 37.05],
		保定: [115.48, 38.85],
		张家口: [114.87, 40.82],
		承德: [117.93, 40.97],
		沧州: [116.83, 38.33],
		廊坊: [116.7, 39.53],
		衡水: [115.72, 37.72],
		
	//省份 山西
		太原: [112.53, 37.87],
		大同: [113.3, 40.12],
		阳泉: [113.57, 37.85],
		长治: [113.08, 36.18],
		临汾: [111.5, 36.08],
	
	//省份 黑龙江
		哈尔滨: [126.63, 45.75],
		齐齐哈尔: [123.97, 47.33],
		大庆: [125.03, 46.58],
		牡丹江: [129.58, 44.6],
		
	//省份 吉林
		长春: [125.35, 43.88],
		吉林: [126.57, 43.87],
	
	//省份 辽宁
		沈阳: [123.38, 41.8],
		// 大连: [121.62, 38.92],
			瓦房店: [121.979603, 39.627114],
		抚顺: [123.97, 41.97],
		本溪: [123.73, 41.3],
		丹东: [124.37, 40.13],
		锦州: [121.15, 41.13],
		营口: [122.18, 40.65],
		盘锦: [122.070714, 41.119997],
		葫芦岛: [120.836932, 40.711052],
		鞍山: [122.85, 41.12],
	//省份 江苏
		// 南京: [118.78, 32.04],
		// 无锡: [120.29, 31.59],
			// 宜兴: [119.82, 31.36],
			// 江阴: [120.26, 31.91],
		// 徐州: [117.2, 34.26],
		// 常州: [119.95, 31.79],
			// 溧阳: [119.48, 31.43],
			金坛: [119.56, 31.74],
		// 苏州: [120.62, 31.32],
			吴江: [120.63, 31.16],
			常熟: [120.74, 31.64],
			张家港: [120.555821, 31.875428],
			// 昆山: [120.95, 31.39],
			太仓: [121.1, 31.45],
		// 南通: [121.05, 32.08],
		// 海门: [121.15, 31.89],
		// 连云港: [119.16, 34.59],
		// 淮安: [119.15, 33.5],
		// 盐城: [120.13, 33.38],
		// 扬州: [119.42, 32.39],
		// 镇江: [119.44, 32.2],
			// 句容: [119.16, 31.95],
		// 泰州: [119.9, 32.49],
		// 宿迁: [118.3, 33.96],
	//省份 浙江
		// 杭州: [120.19, 30.26],
			富阳: [119.95, 30.07],
			临安: [119.72, 30.23],
		宁波: [121.56, 29.86],
		温州: [120.65, 28.01],
		嘉兴: [120.76, 30.77],
		湖州: [120.1, 30.86],
		// 绍兴: [120.58, 30.01],
			诸暨: [120.23, 29.71],
		// 金华: [119.64, 29.12],
			义乌: [120.06, 29.32],
		衢州: [118.88, 28.97],
		舟山: [122.207216, 29.985295],
		台州: [121.420757, 28.656386],
		丽水: [119.92, 28.45],
	//省份 安徽
		合肥: [117.27, 31.86],
		芜湖: [118.38, 31.33],
		马鞍山: [118.48, 31.56],
	//省份 福建
		福州: [119.3, 26.08],
		厦门: [118.1, 24.46],
		泉州: [118.58, 24.93],
	//省份 江西
		南昌: [115.89, 28.68],
		萍乡: [113.89, 27.66],
		九江: [115.97, 29.71],      
		// 吉安: [115.00, 27.11],
			泰和: [114.91, 26.79],
	//省份 山东
		// 青岛: [120.33, 36.07],
			胶州: [120.03336, 36.264622],
			平度: [119.97, 36.77],
			即墨: [120.45, 36.38],
			// 胶南: [119.97, 35.88],
			// 莱西: [120.53, 36.86],
		// 潍坊: [119.1, 36.62],
			// 寿光: [118.73, 36.86],
		东营: [118.49, 37.46],
		菏泽: [115.480656, 35.23375],
		// 烟台: [121.39, 37.52],
			蓬莱: [120.75, 37.8],
			莱州: [119.942327, 37.177017],
			招远: [120.38, 37.35],
		// 威海: [122.1, 37.5],
			荣成: [122.41, 37.16],
			乳山: [121.52, 36.89],
			文登: [122.05, 37.2],
		// 济南: [117, 36.65],
			莱芜: [117.67, 36.19],
			章丘: [117.53, 36.72],
		// 淄博: [118.05, 36.78],
		// 枣庄: [117.57, 34.86],
		// 济宁: [116.59, 35.38],
		// 泰安: [117.13, 36.18],
		// 日照: [119.46, 35.42],
		// 临沂: [118.35, 35.05],
		// 德州: [116.29, 37.45],
		// 聊城: [115.97, 36.45],
		// 滨州: [118.03, 37.36],
	//省份 河南
		郑州: [113.65, 34.76],
		开封: [114.35, 34.79],
		洛阳: [112.44, 34.7],
		平顶山: [113.29, 33.75],
		安阳: [114.35, 36.1],
		新乡: [113.81, 35.19],
		焦作: [113.21, 35.24],
		三门峡: [111.19, 34.76],
	//省份 湖北
		武汉: [114.31, 30.52],
		宜昌: [111.3, 30.7],
		荆州: [112.239741, 30.335165],
	//省份 湖南
		长沙: [113, 28.21],
		株洲: [113.16, 27.83],
		湘潭: [112.91, 27.87],
		衡阳: [111.49, 40.78],
		邵阳: [111.28, 26.99],
		岳阳: [113.09, 29.37],
		常德: [111.69, 29.05],
		张家界: [110.479191, 29.117096],
		益阳: [112.36, 28.55],
		郴州: [113.02, 25.77],
		永州: [111.61, 26.42],
		怀化: [110.00, 27.57],
		娄底: [112.00, 27.70],
		湘西: [109.74, 28.31],  //湘西土家族苗族自治州
	//省份 广东
		广州: [113.23, 23.16],
		韶关: [113.62, 24.84],
		深圳: [114.07, 22.62],
		珠海: [113.52, 22.3],
		汕头: [116.69, 23.39],
		佛山: [113.11, 23.05],
		江门: [113.06, 22.61],
		湛江: [110.359377, 21.270708],
		茂名: [110.88, 21.68],
		肇庆: [112.44, 23.05],
		惠州: [114.4, 23.09],
		梅州: [116.1, 24.55],
		汕尾: [115.375279, 22.786211],
		河源: [114.68, 23.73],
		阳江: [111.95, 21.85],
		清远: [113.01, 23.7],
		东莞: [113.75, 23.04],
		中山: [113.38, 22.52],
		潮州: [116.63, 23.68],
		揭阳: [116.35, 23.55],
		云浮: [112.02, 22.93],
	//省份 海南
		// 海口: [110.35, 20.02],
		// 三亚: [109.511909, 18.252847],
	//省份 四川
		成都: [104.06, 30.67],
		自贡: [104.778442, 29.33903],
		攀枝花: [101.718637, 26.582347],
		泸州: [105.39, 28.91],
		德阳: [104.37, 31.13],
		绵阳: [104.73, 31.48],
		南充: [106.110698, 30.837793],
		宜宾: [104.56, 29.77],
	//省份 贵州
		贵阳: [106.71, 26.57],
		遵义: [106.9, 27.7],
	//省份 云南
		昆明: [102.73, 25.04],
		曲靖: [103.79, 25.51],
		玉溪: [102.52, 24.35],
	//省份 陕西
		西安: [108.95, 34.27],
		铜川: [109.11, 35.09],
		宝鸡: [107.15, 34.38],
		咸阳: [108.72, 34.36],
		渭南: [109.5, 34.52],
		延安: [109.47, 36.6],
	//省份 甘肃
		兰州: [103.73, 36.03],
		嘉峪关: [98.289152, 39.77313],
		金昌: [102.188043, 38.520089],
	//省份 青海
		西宁: [101.74, 36.56],
	//省份 台湾
		// 台湾: [120.79, 23.11],
	//自治区 内蒙古
		呼和浩特: [111.65, 40.82],
		包头: [110, 40.58],
		赤峰: [118.87, 42.28],
		鄂尔多斯: [109.781327, 39.608266],
	//自治区 广西
		凭祥: [106.77, 22.10],
		南宁: [108.33, 22.84],
		柳州: [109.4, 24.33],
		桂林: [110.28, 25.29],
		北海: [109.12, 21.49],
		钦州: [112.94, 28.23],
		贵港: [109.60, 23.11],
		玉林: [110.18, 22.65],
		百色: [106.62, 23.90],
			田东: [107.13, 23.60],
			田林: [106.23, 24.30],
			那坡: [105.83, 23.39],
		贺州: [111.57, 24.40],
		河池: [108.64, 24.49],
	//自治区 西藏
		拉萨: [91.11, 29.97],
	//自治区 宁夏
		银川: [106.27, 38.47],
		石嘴山: [106.39, 39.04],
	//自治区 新疆
		库尔勒: [86.06, 41.68],
		乌鲁木齐: [87.68, 43.77],
		克拉玛依: [84.77, 45.59],
	//直辖市 北京
		北京: [116.46, 39.92],
	//直辖市 天津
		天津: [117.2, 39.13],
	//直辖市 上海
		上海: [121.48, 31.22],
	//直辖市 重庆
		重庆: [106.54, 29.59],
	//特别行政区 香港
	//特别行政区 澳门
		
};

export default mapDot
